// import React, { useState } from "react";
// import { useAuth } from "./AuthContext";
// import { FiLogOut } from "react-icons/fi";
// import { Modal, Button } from "react-bootstrap";
// import { Card, CardContent, Grid, Typography, Avatar, Box, IconButton, Tooltip } from "@mui/material";

// const Logout = () => {
//   const { logout } = useAuth();
//   const [showConfirmation, setShowConfirmation] = useState(false);

//   const handleLogout = () => setShowConfirmation(true);
//   const handleConfirmLogout = () => {
//     logout();
//     setShowConfirmation(false);
//   };
//   const handleCancelLogout = () => setShowConfirmation(false);

//   return (
//     <>
//       <Tooltip
//         title="Logout" arrow
//         componentsProps={{
//           tooltip: {
//             sx: {
//               backgroundColor: 'brown',
//               color: 'white',
//               border: '1px solid white',
//               fontWeight: 'bold',
//               boxShadow: 2,
//             },
//           },
//         }}
//       >
//         <button onClick={handleLogout} className="logout-button">
//           <FiLogOut />
//         </button>
//       </Tooltip>
//       <Modal
//         show={showConfirmation}
//         onHide={handleCancelLogout}
//         centered
//         backdrop="static"
//         keyboard={false}
//         className="logout-modal"
//       >
//         <Modal.Header closeButton className="border-0">
//           <Modal.Title className="fw-bold">Confirm Logout</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-muted fs-6">
//           Are you sure you want to logout from your account?
//         </Modal.Body>
//         <Modal.Footer className="border-0">
//           <Button
//             variant="outline-secondary"
//             onClick={handleCancelLogout}
//             className="rounded-pill px-4"
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={handleConfirmLogout}
//             className="rounded-pill px-4"
//           >
//             Logout
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default Logout;

import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { FiLogOut } from "react-icons/fi";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Button, MenuItem, IconButton
} from "@mui/material";

const Logout = ({ asMenuItem = false, onAfterLogout }) => {
  const { logout } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleLogoutClick = () => setShowConfirmation(true);
  const handleConfirmLogout = () => {
    logout();
    setShowConfirmation(false);
    if (onAfterLogout) onAfterLogout(); // close menu after logout
  };
  const handleCancelLogout = () => setShowConfirmation(false);

  return (
    <>
      {asMenuItem ? (
        <MenuItem 
          onClick={handleLogoutClick}
          sx={{
            py: 1.25,
            px: 2,
            borderRadius: '8px',
            mx: 0.75,
            my: 0.25,
            fontSize: '14px',
            fontFamily: "'Inter', sans-serif",
            transition: 'all 0.2s ease',
            '&:hover': { backgroundColor: 'rgba(99, 102, 241, 0.15)', color: '#818cf8' }
          }}
        >
          <FiLogOut style={{ marginRight: 12, fontSize: 16 }} /> Logout
        </MenuItem>
      ) : (
        <IconButton 
          onClick={handleLogoutClick} 
          sx={{ 
            color: 'rgba(255, 255, 255, 0.85)',
            transition: 'all 0.2s ease',
            '&:hover': { 
              color: 'white', 
              backgroundColor: 'rgba(255, 255, 255, 0.08)' 
            } 
          }}
        >
          <FiLogOut style={{ fontSize: 20 }} />
        </IconButton>
      )}

      <Dialog 
        open={showConfirmation} 
        onClose={handleCancelLogout}
        PaperProps={{
          sx: {
            borderRadius: '16px',
            p: 1.5,
            minWidth: '320px',
            boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
          }
        }}
      >
        <DialogTitle sx={{ 
          fontFamily: "'Inter', sans-serif", 
          fontWeight: 700, 
          fontSize: '18px', 
          pb: 1,
          color: '#1e293b'
        }}>
          Confirm Logout
        </DialogTitle>
        <DialogContent sx={{ pb: 2 }}>
          <DialogContentText sx={{ 
            fontFamily: "'Inter', sans-serif", 
            fontSize: '14px', 
            color: '#64748b' 
          }}>
            Are you sure you want to logout from your account?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 1, gap: 1 }}>
          <Button 
            onClick={handleCancelLogout} 
            variant="outlined"
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#64748b',
              borderColor: '#cbd5e1',
              px: 3,
              '&:hover': {
                borderColor: '#94a3b8',
                backgroundColor: '#f8fafc',
              }
            }}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConfirmLogout} 
            color="error" 
            variant="contained"
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              backgroundColor: '#ef4444',
              px: 3,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#dc2626',
                boxShadow: 'none',
              }
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Logout;
